import { render, staticRenderFns } from "./NewRegisteredUserProfile.vue?vue&type=template&id=5660d913&scoped=true"
import script from "./NewRegisteredUserProfile.vue?vue&type=script&lang=ts"
export * from "./NewRegisteredUserProfile.vue?vue&type=script&lang=ts"
import style0 from "./NewRegisteredUserProfile.vue?vue&type=style&index=0&id=5660d913&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660d913",
  null
  
)

export default component.exports